<template>
  <div class="publicator">
    <div class="publicator__row">
      <div class="publicator__row-wrapper">
        <Avatar
          class="info__avatar"
          :url="getAvatarImage"
          :fullName="
            item.work_site && item.work_site.options && item.work_site.value
              ? item.work_site.options[item.work_site.value] ||
                item.work_site.value
              : item.work_site.value
          "
          :size="40"
        />
        <div
          v-if="item.work_site.value !== 'career_page'"
          class="publicator__row-wrapper-button"
        >
          <Button
            buttonSize="big"
            buttonColor="blue"
            :buttonText="statusButton.status"
            :disabled="statusButton.disabled"
            class="accept-button"
            @click="handleCommand({ id: 'refresh' })"
          />
        </div>

        <div class="publicator__row-wrapper-content">
          <p
            v-if="
              item.work_site.value == 'career_page' &&
              (item.status.value == 'draft' || item.status.value == 'archived')
            "
            class="content__title fw-500 primary"
          >
            {{ item.name.value | format }}
          </p>
          <a
            v-else
            :href="item.url.value || 'javascript:void(0)'"
            class="content__title fw-500 primary"
            target="_blank"
            >{{ item.name.value | format }}
          </a>
          <p class="content__text secondary">
            {{
              item.area_name.value
                ? `${item.area_name.value}`
                : `${item.area.value || item?.areas?.value}`
            }}
            {{
              item.published_by_name?.value &&
              item.work_site.value == 'rabotaru'
                ? `, ${item.published_by_name.value}`
                : ''
            }}
            {{
              item.work_site.value == 'career_page' && item.status.value
                ? `, ${item.status.options[item.status.value]}`
                : ' '
            }}
            {{
              item.updated_at.value
                ? `, обновлено ${item.updated_at.value}`
                : ' '
            }}
            {{
              item.trudvsem_legal_entity?.value
                ? `, ${formatHtml(item.trudvsem_legal_entity?.value)}`
                : ' '
            }}
            <a
              v-if="
                item.rostrud_integration_status?.value &&
                item.work_site.value == 'rabotaru'
              "
              :href="item.rostrud_integration_url?.value || 'javascript:void()'"
              class="blue"
              target="_blank"
            >
              {{
                item.rostrud_integration_status?.value
                  ? `, ${formatHtml(
                      item.rostrud_integration_status?.value
                    )} на ТрудВсем`
                  : ' '
              }}
            </a>
          </p>
        </div>
      </div>
      <ActionsMenu
        v-if="access"
        :actions="getCurrentActions"
        @handleCommand="handleCommand"
        dropdownIconColor="#99A5B3"
        type="pointsMenu"
        class="publicator__actions"
      />
    </div>
    <PublicatorDeleteDialog
      v-if="is_visible.publicator_delete_dialog"
      @reset-callback="closeDialog('publicator_delete_dialog', null)"
      :external_id="item.external_id?.value"
      :vacancy_id="item.id.value"
      :work_site="item.work_site.value"
      :is_visible="visibleDeletePopup"
    />
    <PublicatorRefreshDialog
      @reset-callback="visibleRefreshPopup = false"
      :external_id="item.external_id?.value"
      :work_site="item.work_site.value"
      :is_visible="visibleRefreshPopup"
    />
  </div>
</template>

<script>
import Button from 'Elements/Button/Button';
import Avatar from 'Elements/Avatar/Avatar';
import { store } from '@/store';
import PublicatorDeleteDialog from 'Elements/Dialog/PublicatorDeleteDialog';
import PublicatorRefreshDialog from 'Elements/Dialog/PublicatorRefreshDialog';
import ActionsMenu from 'Elements/Menu/ActionsMenu';
import { mixin, errorMsg } from '@/utils/mixins';
export default {
  components: {
    PublicatorRefreshDialog,
    PublicatorDeleteDialog,
    Avatar,
    Button,
    ActionsMenu
  },
  mixins: [mixin, errorMsg],
  data() {
    return {
      vacancyActions: [
        {
          id: 'edit',
          name: 'Редактировать'
        },
        {
          id: 'edit_publish',
          name: 'Редактировать и опубликовать'
        },
        {
          id: 'toArchive',
          name: 'В архив'
        },
        {
          id: 'publish',
          name: 'Опубликовать'
        },
        {
          id: 'delete',
          name: 'Удалить'
        },
        {
          id: 'deactivate',
          name: 'Деактивировать'
        },
        {
          id: 'duplicate',
          name: 'Дублировать'
        },
        {
          id: 'show',
          name: 'Показать'
        },
        {
          id: 'hide',
          name: 'Скрыть'
        },
        {
          id: 'utm',
          name: 'UTM-МЕТКИ',
          children: [
            {
              id: 'listUTM',
              name: 'Активные'
            },
            {
              id: 'bindUTM',
              name: 'Связать с публикацией'
            },
            {
              id: 'addUTM',
              name: 'Добавить новые'
            }
          ]
        }
      ],
      statusButton: {
        disabled: false,
        status: 'Обновить'
      },
      visibleDeletePopup: false,
      visibleRefreshPopup: false
    };
  },
  props: {
    index: Number,
    item: {
      type: Object
    },
    access: Boolean
  },
  methods: {
    closeDeletePopup() {
      this.visibleDeletePopup = false;
    },
    btnConfig() {
      if (
        this.item.work_site.value == 'trudvsem' &&
        this.item.status.value &&
        this.item.status.options &&
        Object.keys(this.item.status.options).length
      ) {
        this.statusButton.status =
          this.item.status.options[this.item.status.value];
        this.statusButton.disabled = true;
      } else if (this.item.status.value === 'published') {
        this.statusButton.status =
          this.item.work_site.value != 'rabotaru' ? 'Обновить' : 'Опубликована';
        this.statusButton.disabled =
          this.item.work_site.value != 'rabotaru' ? false : true;
      } else if (this.item.status.value === 'archived') {
        this.statusButton.status = 'В архиве';
        this.statusButton.disabled = true;
      } else if (this.item.status.value === 'draft') {
        this.statusButton.status = 'Черновик';
        this.statusButton.disabled = true;
      } else if (this.item.status.value === 'deleted') {
        this.statusButton.status = 'Удалена';
        this.statusButton.disabled = true;
      } else if (this.item.status.value === 'blocked') {
        this.statusButton.status = 'Заблокирована';
        this.statusButton.disabled = true;
      } else if (this.item.status.value === 'unpublished') {
        this.statusButton.status = 'Не опубликована';
        this.statusButton.disabled = true;
      }
      if (this.item.status.value === 'blocked') {
        this.statusButton.status = 'Заблокирована';
        this.statusButton.disabled = true;
      } else if (this.item.status.value === 'unpublished') {
        this.statusButton.status = 'Не опубликована';
        this.statusButton.disabled = true;
      }
    },
    async handleCommand(command) {
      store.commit('publicator/setVacancyItem', this.item);

      switch (command.id) {
        case 'toArchive':
          if (!this.auth.length) {
            return store.dispatch('common/catchError', {
              msg: 'Требуется авторизация'
            });
          } else {
            if (this.auth[0]?.authData && !this.auth[0]?.authData.employer) {
              return store.dispatch('common/catchError', {
                msg: 'Текущий пользователь не является работодателем'
              });
            } else {
              await store.dispatch('publicator/archivePublishedVacancy', {
                external_id: this.item.external_id.value,
                employer_id: this.auth[0]?.authData?.employer.id || '',
                work_site: this.item.work_site.value
              });
            }
          }
          break;

        case 'deactivate':
          await store.dispatch('publicator/deactivatePublishedVacancy', {
            external_id: this.item.external_id.value,
            work_site: this.item.work_site.value
          });
          await store.dispatch(
            'publicator/setSelectedPublishedVacancyAsync',
            null
          );
          break;

        case 'delete':
          if (!this.auth.length || !Object.keys(this.auth[0].authData).length) {
            return store.dispatch('common/catchError', {
              msg: 'Требуется авторизация'
            });
          } else {
            if (
              this.auth[0].authData &&
              !this.auth[0].authData.employer &&
              this.item.status.value != 'draft'
            ) {
              return store.dispatch('common/catchError', {
                msg: 'Текущий пользователь не является работодателем'
              });
            } else if (
              this.item.work_site.value == 'avito' &&
              this.item.status.value == 'archived'
            ) {
              return store.dispatch('common/catchError', {
                msg: 'Avito: невозможно удалить вакансию. Вакансия в Авито будет удалена автоматически по истечении 30 дней с момента архивации.'
              });
            } else {
              store.commit('publicator/setSelectedPublishedVacancy', this.item);
              this.is_visible.publicator_delete_dialog = true;
              this.visibleDeletePopup = true;
            }
          }

          break;
        case 'refresh':
          if (!this.auth.length) {
            return store.dispatch('common/catchError', {
              msg: 'Требуется авторизация'
            });
          } else {
            if (this.auth[0].authData && !this.auth[0].authData.employer) {
              return store.dispatch('common/catchError', {
                msg: 'Текущий пользователь не является работодателем'
              });
            } else {
              this.visibleRefreshPopup = true;
            }
          }

          break;
        case 'publish':
          if (
            this.item.status.value === 'draft' ||
            this.item.status.value === 'unpublished'
          ) {
            await store.dispatch('publicator/savePublishedVacancy', {
              ...this.item,
              only_publish: true
            });
          } else {
            await store.dispatch('publicator/copyPublishedVacancy', {
              external_id: this.item.external_id.value,
              work_site: this.item.work_site.value
            });
          }
          break;

        case 'hide':
        case 'show':
          await store.dispatch('publicator/showPublishedVacancy', {
            external_id: this.item.external_id.value,
            visibility_vacancy:
              command.id == 'hide' ? 'HIDDEN' : 'VISIBLE_TO_ALL'
          });

          break;

        case 'edit':
          store.commit('publicator/setSelectedPublishedVacancy', {
            ...this.item,
            edited: true
          });
          this.is_visible.publicator_dialog = true;
          break;

        case 'duplicate':
          store.commit('publicator/setSelectedPublishedVacancy', {
            ...this.item,
            duplicate: true
          });
          this.is_visible.publicator_dialog = true;
          break;

        case 'edit_publish':
          store.commit('publicator/setSelectedPublishedVacancy', {
            ...this.item,
            edited: true
          });
          this.is_visible.publicator_dialog = true;
          break;

        case 'listUTM':
          store.commit('publicator/setSelectedPublishedVacancy', this.item);
          store.commit('common/setVisibleDialog', {
            name: 'publicator_utm_list_dialog',
            val: true
          })
          break;

        case 'bindUTM':
          store.commit('publicator/setSelectedPublishedVacancy', this.item);
          store.commit('common/setVisibleDialog', {
            name: 'publicator_utm_binding_dialog',
            val: true
          })
          break;

        case 'addUTM':
          store.commit('common/setVisibleDialog', {
            name: 'publicator_utm_creation_dialog',
            val: true
          })
          break;

        default:
          break;
      }
    }
  },
  computed: {
    getAvatarImage() {
      let site = this.item.work_site.value;
      if (site == 'hh') {
        return '/front/src/assets/img/hh.png';
      } else if (site == 'career_page') {
        return '/front/src/assets/img/career.png';
      } else if (site == 'superjob') {
        return '/front/src/assets/img/superjob.png';
      } else if (site == 'avito') {
        return '/front/src/assets/img/avito.png';
      } else if (site == 'trudvsem') {
        return '/front/src/assets/img/TrudVsem.png';
      } else if (site == 'rabotaru') {
        return '/front/src/assets/img/rabotaru.png';
      } else {
        return '/front/src/assets/img/head_hunter.png';
      }
    },

    auth() {
      return store.state.publicator.authForm.filter(
        el => el.name === this.item.work_site.value
      );
    },
    is_visible() {
      return store.state.common.visible_dialog;
    },
    getCurrentActions() {
      return (
        (this.item.status.value === 'published' &&
          this.item.work_site.value != 'rabotaru' &&
          this.item.work_site.value != 'career_page' &&
          this.item.work_site.value != 'trudvsem' &&
          this.vacancyActions.filter(
            item =>
              item.id !== 'edit_publish' &&
              item.id !== 'publish' &&
              item.id !== 'delete' &&
              item.id !== 'deactivate' &&
              item.id !== 'duplicate' &&
              item.id !== 'show' &&
              item.id !== 'hide' &&
              item.id !== 'utm'
          )) ||
        (this.item.status.value === 'archived' &&
          this.item.work_site.value != 'rabotaru' &&
          this.item.work_site.value != 'career_page' &&
          this.item.work_site.value != 'trudvsem' &&
          this.vacancyActions.filter(
            item =>
              item.id !== 'edit_publish' &&
              item.id !== 'toArchive' &&
              item.id !== 'edit' &&
              item.id !== 'deactivate' &&
              item.id !== 'duplicate' &&
              item.id !== 'show' &&
              item.id !== 'hide' &&
              item.id !== 'utm'
          )) ||
        (this.item.status.value === 'archived' &&
          this.item.work_site.value == 'career_page' &&
          // !this.getPublishedVacancy.some(
          //   v =>
          //     v.work_site.value == 'career_page' &&
          //     v.status.value == 'published'
          // ) &&
          this.vacancyActions.filter(
            item => item.id == 'publish' || item.id == 'edit'
          )) ||
        (this.item.status.value === 'draft' &&
          this.item.work_site.value == 'career_page' &&
          !!this.statusButton.disabled &&
          // !this.getPublishedVacancy.some(
          //   v =>
          //     v.work_site.value == 'career_page' &&
          //     v.status.value == 'published'
          // ) &&
          this.vacancyActions.filter(
            item =>
              item.id !== 'edit_publish' &&
              item.id !== 'toArchive' &&
              item.id !== 'deactivate' &&
              item.id !== 'delete' &&
              item.id !== 'duplicate' &&
              item.id !== 'show' &&
              item.id !== 'hide' &&
              item.id !== 'utm'
          )) ||
        (this.item.work_site.value != 'career_page' &&
          this.item.work_site.value != 'rabotaru' &&
          this.item.work_site.value != 'trudvsem' &&
          this.vacancyActions.filter(
            item =>
              item.id !== 'edit' &&
              item.id !== 'toArchive' &&
              item.id !== 'deactivate' &&
              item.id !== 'duplicate' &&
              item.id !== 'show' &&
              item.id !== 'hide' &&
              item.id !== 'utm'
          )) ||
        (this.item.work_site.value == 'career_page' &&
          this.vacancyActions.filter(
            item =>
              item.id !== 'edit_publish' &&
              item.id !== 'toArchive' &&
              item.id !== 'delete' &&
              item.id !== 'publish' &&
              item.id !== 'duplicate' &&
              item.id !== 'show' &&
              item.id !== 'hide'
          )) ||
        (this.item.work_site.value == 'trudvsem' &&
          (this.item.status.value === 'waiting' ||
            this.item.status.value === 'blocked') &&
          this.vacancyActions.filter(
            item =>
              item.id !== 'edit_publish' &&
              item.id !== 't  oArchive' &&
              item.id !== 'deactivate' &&
              item.id !== 'publish' &&
              item.id !== 'show' &&
              item.id !== 'hide' &&
              item.id !== 'utm'
          )) ||
        (this.item.status.value === 'draft' &&
          this.item.work_site.value == 'trudvsem' &&
          this.vacancyActions.filter(
            item =>
              item.id !== 'edit' &&
              item.id !== 'toArchive' &&
              item.id !== 'deactivate' &&
              item.id !== 'duplicate' &&
              item.id !== 'show' &&
              item.id !== 'hide' &&
              item.id !== 'utm'
          )) ||
        (this.item.status.value === 'published' &&
          this.item.work_site.value == 'trudvsem' &&
          this.vacancyActions.filter(
            item =>
              item.id !== 'edit_publish' &&
              item.id !== 'toArchive' &&
              item.id !== 'deactivate' &&
              item.id !== 'publish' &&
              item.id !== 'show' &&
              item.id !== 'utm'
          )) ||
        (this.item.status.value === 'hidden' &&
          this.item.work_site.value == 'trudvsem' &&
          this.vacancyActions.filter(
            item =>
              item.id !== 'edit_publish' &&
              item.id !== 'toArchive' &&
              item.id !== 'deactivate' &&
              item.id !== 'publish' &&
              item.id !== 'hide' &&
              item.id !== 'utm'
          )) ||
        (this.item.status.value === 'draft' &&
          this.item.work_site.value == 'rabotaru' &&
          this.vacancyActions.filter(
            item =>
              item.id == 'edit_publish' ||
              item.id == 'publish' ||
              item.id == 'delete'
          )) ||
        (this.item.status.value === 'published' &&
          this.item.work_site.value == 'rabotaru' &&
          this.vacancyActions.filter(
            item =>
              item.id == 'edit' || item.id == 'toArchive' || item.id == 'delete'
          )) ||
        (this.item.status.value === 'archived' &&
          this.item.work_site.value == 'rabotaru' &&
          this.vacancyActions.filter(
            item => item.id == 'publish' || item.id == 'delete'
          )) ||
        (this.item.status.value === 'blocked' &&
          this.item.work_site.value == 'rabotaru' &&
          this.vacancyActions.filter(
            item => item.id == 'edit' || item.id == 'delete'
          )) ||
        (this.item.status.value === 'unpublished' &&
          this.item.work_site.value == 'rabotaru' &&
          this.vacancyActions.filter(
            item => item.id === 'edit_publish' || item.id === 'delete'
          ))
      );
    },
    getPublishedVacancy() {
      return store.state.publicator.publishedVacancy;
    },
    dateModifer() {
      if (!this.item.published_at.value) return;
      return this.item.published_at.value.split(' ').shift();
    },
    workSiteChecked() {
      return this.item.work_site.value == 'career_page'
        ? this.item.status.value != 'published'
          ? !this.getPublishedVacancy.some(
              v =>
                v.work_site.value == 'career_page' &&
                v.status.value == 'published'
            )
          : true
        : true;
    }
  },
  beforeMount() {
    this.btnConfig();
  }
};
</script>
<style lang="scss" scoped>
.publicator {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 4px;
  padding: 12px;
  align-items: center;

  &:hover {
    background: $blue-10;

    .publicator__row {
      &-wrapper-content {
        a {
          color: $blue-120;
        }
      }
    }
  }

  &__row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &-wrapper {
      display: flex;
      width: 100%;

      &-button {
        width: 17%;
      }

      .info__avatar {
        margin-right: 16px;

        &::v-deep .el-avatar {
          background-color: white;
        }
      }

      &-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 16px;

        a {
          color: $black-200;
          max-width: 468px;
        }
      }

      &-download {
        height: 48px;
        width: 48px;

        &::v-deep .button-content {
          margin: 0;
        }
      }

      &-delete {
        margin: 0 12px 0 0;
        display: none;

        &::v-deep .button-content {
          margin: 0;
        }
      }
    }
  }
}

.document:hover .document__row-delete,
.document .document__row-delete.is-visible {
  margin: 0 12px 0 0;
  display: inline;
}

.content {
  &__title {
    margin: 0;
    font-size: 16px;
    color: $blue-120;
    line-height: 24px;
  }

  &__text {
    margin: 0;
    font-size: 14px;
    // color: $black-40;
    line-height: 20px;
    font-weight: normal;
  }
}
</style>
